import { CapabilityType, Capability, PlacementType } from '../types/wargame-capabilities';

export const CAPABILITY_DEFINITIONS: Record<CapabilityType, Capability & { allowedPlacements: PlacementType[] }> = {
  MILDEC: {
    type: 'MILDEC',
    placement: 'Community', // Default/Primary
    allowedPlacements: ['Community'],
    cost: 3,
    effects: [
      'Falsifies community belief/behavior to enemy ISR',
      'Affects 5 populations message status visibility',
      'Permanent until removed'
    ]
  },
  NK_Fires: {
    type: 'NK_Fires',
    placement: 'Population',
    allowedPlacements: ['Population'],
    cost: 2,
    effects: [
      'Removes ALL messages from target population',
      'Instantaneous (Single Use)'
    ]
  },
  PPP: {
    type: 'PPP',
    placement: 'Community',
    allowedPlacements: ['Community'],
    cost: 1,
    effects: [
      'Messages 3 populations in 3 random communities (Alone)',
      'Messages ALL open populations (with MISO)',
      'Instantaneous'
    ]
  },
  ISR: {
    type: 'ISR',
    placement: 'Community',
    allowedPlacements: ['Community', 'Population'],
    cost: 2,
    effects: [
      'Community: Reveals all populations, ownership, belief',
      'Population: Reveals 5 closest messages per team',
      'Permanent until removed'
    ]
  },
  OPSEC: {
    type: 'OPSEC',
    placement: 'Community',
    allowedPlacements: ['Community', 'Population'],
    cost: 2,
    effects: [
      'Community: Reveals capabilities, negates MISO/Magic',
      'Population: Negates ISR on target and adjacent',
      'Permanent until removed'
    ]
  },
  MISO: {
    type: 'MISO',
    placement: 'Community',
    allowedPlacements: ['Community', 'Population'],
    cost: 1,
    effects: [
      'Community: Directs PPP to message all open populations',
      'Population: Prevents ILOE degradation',
      'Permanent until removed'
    ]
  },
  Magic: {
    type: 'Magic',
    placement: 'Community',
    allowedPlacements: ['Community', 'Population'],
    cost: 3,
    effects: [
      'Community: Increases ILOE costs by +1',
      'Population: Treats population as owned for ILOE start',
      'Temporary (End of Stage)'
    ]
  }
};

export const getCapabilityDefinition = (type: CapabilityType) => CAPABILITY_DEFINITIONS[type];

export const canPlaceCapability = (
  type: CapabilityType, 
  targetType: PlacementType, 
  availableSlots: number
): boolean => {
  const def = CAPABILITY_DEFINITIONS[type];
  if (!def.allowedPlacements.includes(targetType)) return false;
  if (availableSlots < def.cost) return false;
  return true;
};
